module.exports = __webpack_public_path__ + "static/media/promo_band_3.560759b9.jpg";